import { TanStackDevtools } from '@tanstack/react-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { initStore } from 'store/store';
import App from './App';
import './index.scss';
import axios from 'axios';
import { registerMaintenanceModeInterceptor, startBrowserSession } from '@urbanx/agx.auth.client';

registerMaintenanceModeInterceptor(axios, import.meta.env.BASE_URL);

// Store a session ID to be passed to the APIs as an x-session-id header.
startBrowserSession();

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

const store = initStore();

root.render(
  <Provider store={store}>
    <App />
    {import.meta.env.DEV && <TanStackDevtools plugins={[formDevtoolsPlugin()]} />}
  </Provider>
);
